export class Responsible {
  // Calender id
  id: string;
  Code: string;
  Name: string;
  E_Mail: string;
  Date_Period_Setup: string;
  App_Category_Filter: string;
  App_Status_Filter: string;
  App_Responsible_Filter: string;
  App_Company_Filter: string;
  App_Show_OTS_Filter: string;
  Resource: string;
}

export class UserFilters {
  APPTASKCATEGORY: string;
  COMPANY: string;
  OTS_RESPONSIBLE: string;
  STATUS: string;
}



// WEBPACK FOOTER //
// C:/Projects/ePlanner Maintenance/src/app/entities/SalesPerson.ts